import React from "react";
import { Header } from "arv-extends";
import "./NnnowBar";

const { wrapper, getFinalComponent } = Header.MobileHeader.MainBar;
const { NnnowBar } = Header.MobileHeader;

class ProjectComponent extends wrapper {
  get hideIfNotBrandpageClassName() {
    return (!this.props.CommonStore.isBrandPage && "nwc-hide") || "";
  }

  get hideIfBrandpageClassName() {
    return (this.props.CommonStore.isBrandPage && "nwc-hide") || "";
  }
  render() {
    return (
      <div>
        <div className={this.hideIfBrandpageClassName}>
          <NnnowBar.component />
        </div>
      </div>
    );
  }
}

Header.MobileHeader.MainBar.component = getFinalComponent(ProjectComponent);
